import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import * as _ from 'underscore';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { IProductSearchFilter } from '../../../api';
import { ICampaignProductLink } from '../../../campaigns/models';
import { IProductSearchItem, IProductSearchPagingResult } from '../../models';
import { ProductsService } from '../../products.service';

class ProductSearchController implements ng.IController {
    public static $inject = ['$scope', 'productsService', 'notificationService', '$translate', '$localStorage'];

    public searchTerm: string;
    public pagination = {
        data: [],
        page: 1,
        pageSize: 10,
        total: 0
    };
    public waiting = false;
    public countryID: number;
    private resolve = {
        items: [],
        categories: null as number,
    };

    private categories = {
        selected: null as any,
        list: null as any,
        enabled: false as boolean,
    };

    private selectedProducts: { [id: number]: ICampaignProductLink; } = {};
    private modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;

    constructor(
        $scope: angular.IScope,
        private productsService: ProductsService,
        private notification: NotificationService,
        private $translate: angular.translate.ITranslateService,
        private $localStorage: ngStorage.StorageService
    ) {
        $scope.$watch('$ctrl.categories.selected', () => {
            this.loadData();
        });
    }

    public $onInit() {
        if (this.resolve && !_.isEmpty(this.resolve.items)) {
            _.forEach(this.resolve.items, (item: ICampaignProductLink) => this.selectedProducts[item.productId] = item);
        }

        if (this.resolve.categories) {
            this.categories.enabled = true;
            this.loadCategories();
        }

        this.loadData();
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    }

    public selectProduct(product: ICampaignProductLink) {
        product.isSelected = !product.isSelected;

        if (product.isSelected) {
            this.selectedProducts[product.productId] = product;
            return;
        }

        this.selectedProducts[product.productId] = null;
    }

    public getSelectedCount(): number {
        return this.getSelectedProducts().length;
    }

    public confirm() {
        this.modalInstance.close({ $value: this.getSelectedProducts() });
    }

    public onSearchInputKeyPress($event: any) {
        if ($event.which === 13 && !this.waiting) {
            this.loadData();
        }
    }

    private search(text: string) {
        this.searchTerm = text;
        this.loadData();
    }

    private resetSearch() {
        this.searchTerm = '';
        this.search(this.searchTerm);
    }

    private loadCategories() {
        this.productsService.getItemTypes(this.resolve.categories, null)
            .then((itemTypes) => {
                this.categories.list = Array.from(new Set(itemTypes.map((item) => item.ID))).map((id) => {
                      return itemTypes.find((value) => value.ID === id);
                  });
                this.categories.list.unshift({ ID: null, SingleForm: this.$translate.instant('all_categories') });
                this.categories.selected = this.categories.list[0];
            })
            .catch((error) => console.log(error));
    }

    private async loadData() {
        const filter: IProductSearchFilter = {
            limit: this.pagination.pageSize,
            offset: (this.pagination.page - 1) * this.pagination.pageSize,
            searchTerm: this.searchTerm,
            sortColumn: 'UpdateDate',
            sortOrder: 'descending',
            itemTypeID: this.categories.selected ?
                this.categories.selected.ID : null,
            categoryID: this.resolve.categories
        };

        this.notification.showWaitingMessage();
        this.waiting = true;
        try {
            const result =  await this.productsService.findProducts(filter);
            this.pagination.data = this.mapSearchResult(result);
            this.pagination.total = result.Total;
            this.notification.clearAll();
        } catch (e) {
            this.notification.showErrorMessage(e);
        }
        this.waiting = false;
    }

    private mapSearchResult(result: IProductSearchPagingResult): ICampaignProductLink[] {
        return _.map(result.Items, (product) => this.mapSearchProduct(product));
    }

    private mapSearchProduct(source: IProductSearchItem): ICampaignProductLink {
        return {
            id: 0,
            productId: source.ID,
            imageId: source.ImageID,
            title: source.Title,
            minPrice: source.MinPrice,
            maxPrice: source.MaxPrice,
            oldPrice: source.OldPrice,
            imageUrl: this.productsService.getImageUrl(source.ImageID, 60),
            isSelected: this.selectedProducts[source.ID] != null,
            currencySign: source.CurrencySign,
            itemTypeName: source.ItemTypeName,
            itemTypeID: source.ItemTypeID,
            classificationCategoryID: source.ClassificationCategoryID,
            variants: source.Variants,
        };
    }

    private getSelectedProducts() {
        return _.filter(this.selectedProducts, (v: any) => v || false);
    }
}

angular.module('naut').component('productSearch', {
    template: require('./product.search.component.html'),
    controller: ProductSearchController,
    controllerAs: '$ctrl',
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/product-search/product.search.component.ts